import styled from 'styled-components'

import type { OptionLabelType } from './types'

export const OptionContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`

export const OptionLabel = styled.span<OptionLabelType>`
  font-family: ${({ theme }) => theme.fonts.mainFont};
  width: ${({ $isSelected, $isMulti }) =>
    $isSelected && $isMulti ? '85%' : '100%'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export const MenuFooter = styled.div`
  margin: 10px 15px -25px 15px;
`
